module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-16.a9a18154.mp3";